// Placeholder for OIDC login implementation
export function useInhibitLogout(message: string): void {
  // This is a placeholder implementation
}